<template>
  <documents-table
    :headers="headers"
    :items="documents"
    :zipFileName="zipFileName"
    groupBy="documentType.documentTypeId"
    groupName="documentTypeName"
  >
    <template v-slot:actionButton="">
      <v-col cols="12" sm="2" :class="isMobile ? null : 'pt-4'">
        <upload-document-button
          v-if="!isProvider"
          :clientId="clientId"
          :ageCategory="ageCategory"
        ></upload-document-button></v-col
    ></template>
    <template v-slot:toggle>
      <v-col cols="12" sm="2">
        <v-switch v-model="showPrevious" label="Show Previous" dense></v-switch
      ></v-col>
    </template>
    <template v-slot:actions="{ item }">
      <upload-document-button
        v-if="!isProvider"
        :documentType="item.documentType"
        :file="item"
        :ageCategory="ageCategory"
      ></upload-document-button>
      <delete-document v-if="isAdmin" :fileId="item.fileId"> </delete-document>
    </template>
  </documents-table>
</template>

<script>
import UploadDocumentButton from "../../Shared/upload-document-button";
import DocumentsTable from "../../Client/Details/documents-table";
import DeleteDocument from "./delete-document";

export default {
  components: {
    UploadDocumentButton,
    DocumentsTable,
    DeleteDocument,
  },
  props: ["clientId", "ageCategory"],
  data() {
    return {
      headers: [
        {
          text: "File Name",
          value: "fileName",
        },
        {
          text: "Uploaded At",
          value: "formattedUploadedAt",
        },
        {
          text: "Document Type",
          value: "documentType.name",
          align: " d-none",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
        },
      ],
      showPrevious: false,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
    isProvider() {
      return this.$store.getters["securityModule/isProvider"];
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    documents() {
      var documents = this.$store.getters[
        "clientModule/getDocumentsForAgeCategory"
      ](this.ageCategory);
      var currentPlanIds = this.$store.state.plansModule.plans
        ?.filter((x) => x.isActive)
        .map((x) => x.planId);
      return documents.filter(
        (item) =>
          this.showPrevious ||
          item.planId == null ||
          currentPlanIds.includes(item.planId)
      );
    },
    zipFileName: function () {
      return `${this.clientName}_Documents.zip`;
    },
    clientName() {
      return this.$store.state.clientModule.selectedClient.fullName;
    },
  },
};
</script>